module.exports = __webpack_public_path__ + "static/amazon_prime-2887e70e5c6d8ff332ba6fc9334a9723.png";